export const messages = {
  en: {
    applyReturnOrder: {
      title: 'Return Order',
      orderNumber: 'Order Number',
      user: 'User',
      totalAmount: 'Total Amount',
      paymentAmount: 'Payment Amount',
      time: 'Time',
      operation: 'Operation',
      delete: 'Delete',
      description: 'Description',
      returnRemark: 'Return Remark',
      remarkPlaceholder: 'Required, please fill in the return description',
      submit: 'Submit',
      cancel: 'Cancel',
      selectOrder: 'Select Order',
      confirm: 'Confirm',
      closeConfirm: 'Confirm to close?',
      selectAtLeastOne: 'Please select at least one order'
    }
  },
  zh: {
    applyReturnOrder: {
      title: '退货订单',
      orderNumber: '订单编号',
      user: '用户',
      totalAmount: '总金额',
      paymentAmount: '支付金额',
      time: '时间',
      operation: '操作',
      delete: '删除',
      description: '说明',
      returnRemark: '退货说明',
      remarkPlaceholder: '必填，请填写退货说明',
      submit: '提交',
      cancel: '取消',
      selectOrder: '选择订单',
      confirm: '确定',
      closeConfirm: '确认关闭？',
      selectAtLeastOne: '请至少选择一条订单'
    }
  }
}